<img [src]="pictureUrl" alt="" />
<p>{{ message }}</p>
<ng-content></ng-content>
